import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { empty } from 'rxjs';
import { StorageService } from 'src/services/storage.service';
import { VtigerService } from '../api/api';
import { saveAs } from 'file-saver';
import { LoadingController, IonSlides, ModalController, ToastController } from '@ionic/angular';
import { FilterPipe } from '../filter/filter.pipe';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss']
})
export class ModalContentComponent {
  @Input() proyecto: any;
  @Input() userEmail: string;
  @Input() emailSubject: string;

  emailBody: string;

  constructor(private modalController: ModalController, private toastController: ToastController, public loadingController: LoadingController, private storageService: StorageService, public router: Router, private route: ActivatedRoute, private api: VtigerService, private http: HttpClient, private translate: TranslateService) {

  }

  closeModal() {
    this.modalController.dismiss();
  }

  sendEmail() {
    // Aquí deberías implementar la lógica para enviar el correo
    console.log('Enviando correo...');
    console.log('Asunto:', this.emailSubject);
    console.log('Cuerpo:', this.emailBody);
    console.log('Proyecto:', this.proyecto, this.proyecto['id']);
    console.log('Email del usuario:', this.userEmail);

    this.api.sendmail_pr(this.emailSubject, this.emailBody, this.proyecto['id'], this.userEmail).then(async (res: any) => {
      if (res) {
        if (res.success) {
          const toast = await this.toastController.create({
            message: await this.translate.instant('El correo ha sido enviado, en breve tendrá una respuesta.'),
            duration: 1500,
            position: 'top'
          });

          await toast.present();
        } else {
          const toast = await this.toastController.create({
            message: await this.translate.instant('Ha ocurrido un error'),
            duration: 1500,
            position: 'top'
          });

          await toast.present();
        }


      } else {

      }
    });

  }
}
